import { ICollaborationRepository } from "../../../domain/collaboration";
import { AuthenticatedService } from "../..";
import { ICollaborationStatusBean } from "./beans";

export class CollaborationRepository extends AuthenticatedService implements ICollaborationRepository {
  constructor(getToken: () => string) {
    super(getToken);
  }
  
  public async getDocumentId(externalDocumentId: string, patientNo?: string): Promise<number> {
    // V1稼働済サイトにも対応できるようにV1相当の変換を実装.汚れた実装はここに閉じ込める.
    if (!externalDocumentId || externalDocumentId === "") { throw new Error("externalDocumentId is empty!!!"); }
    const splitted = externalDocumentId.split("-");
    const patientCode = (!patientNo && (1 < splitted.length))
      ? splitted[0]
      : patientNo;
    const externalId = (1 < splitted.length)
      ? splitted[1]
      : externalDocumentId;
    const url = "/api/collaboration/documentid";
    const query = {
      params: {
        patientCode,
        externalId,
      }
    };
    const result = await this.get(url, query);
    return result.data as number;
  }

  public async isScanned(patientCode: string, documentId: number): Promise<boolean> {
    if (!patientCode) { throw new Error("patientCode is empty!!!"); }
    if (documentId == null) { throw new Error("documentId is empty!!!"); }
    const url = "/api/collaboration/document/" + documentId + "/status";
    const query = {
      params: {
        patientCode,
      }
    };
    const result = await this.get(url, query);
    const status = result.data as ICollaborationStatusBean;
    return status && status.isScanned;
  }
}
